import React, { useRef } from "react";
import { useTranslation } from "@lib/i18n";
import { bool, func, string } from "prop-types";

import Modal from "@components/shared/Modal";
import Typography from "@components/shared/Typography";
import { Button } from "@components/shared/Button";
import RequestButton from "@components/shared/RequestButton";

import { useResetClientState } from "@hooks/useResetClientState";

const ClearStorageModal = ({
  title,
  message,
  isOpen,
  onCancel,
  hideCancelButton,
  onBeforeClear,
  onAfterClear,
}) => {
  const { t } = useTranslation();
  const resetClientState = useResetClientState();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  const handleClearStore = async () => {
    onBeforeClear?.();
    resetClientState();
    onAfterClear?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      disableBackdropClick
      disableEscapePress
      ariaLabel={title ?? t("appInfoHandler.versionChanged")}
    >
      <div className="flex flex-col items-center h-full gap-4 py-4 text-center">
        <h4 className="text-xl font-semibold">
          {title ?? t("appInfoHandler.versionChanged")}
        </h4>
        <Typography>
          {message ?? t("appInfoHandler.explanationText")}
        </Typography>
        <div className="flex items-center justify-center w-full">
          <RequestButton
            ref={modalFirstElement}
            triggerRequestCallback={handleClearStore}
          >
            {t("appInfoHandler.clear")}
          </RequestButton>
          {!hideCancelButton && (
            <Button ref={modalLastElement} onClick={onCancel} variant="primary">
              {t("appInfoHandler.cancel")}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

ClearStorageModal.propTypes = {
  isOpen: bool.isRequired,
  onCancel: func,
  onBeforeClear: func,
  onAfterClear: func,
  title: string,
  message: string,
  hideCancelButton: bool,
};

export default ClearStorageModal;
